export default __webpack_public_path__ + "static/media/ktb.1837d683.svg";